import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initCreateTestVoeOrder() {
	const createTestOrderButton = document.querySelector('.create-test-order-button');

	createTestOrderButton.addEventListener('click', createOrder);

	const fields = [
		'first_name',
		'last_name',
		'ssn',
		'date_of_birth',
		'job_title',
		'start_date',
		'end_date',
		'total_time_with_employer',
		'reason_for_leaving',
		'company_name',
		'employer_address',
		'employer_city',
		'employer_state_code',
		'employer_zip_code',
		'employer_url',
		'employer_telephone',
		'employer_email',
	];

	// Init date fields
	document.querySelectorAll('.flat-picker-date').forEach(input => {
		initFlatPickerInput(input, {
			defaultDate: null,
		});
	});

	/**
	 * Methods
	 */

	function createOrder() {
		const data = getInputsByName(document.body, fields);

		loading();

		clearFeedbacksByName(document.body);

		Axios.post(window['routes/client.sandbox.create-test-voe-order.store'], data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {initCreateTestVoeOrder}
